import { setLanguage } from "@actions/profile";
import { LANGUAGES } from "@enums";
import React from "react";
import {
	Translate,
	getActiveLanguage,
	getLanguages,
	getTranslate,
	setActiveLanguage,
} from "react-localize-redux";
import { connect } from "react-redux";
import { ActiveLanguage, ChangeLanguageWrapper, LanguageWrapper } from "./elements";

const ChangeLanguage = ({
	supportedLanguages,
	setActiveLanguage,
	setLanguage,
	currentLanguage,
}) => {
	const isLanguageSupported = (code) => supportedLanguages.find((lang) => lang.code === code);

	const changeLang = (code) => {
		localStorage.setItem("lang", code);
		setActiveLanguage(code);
		setLanguage(code);
	};

	const flags = {
		tr: "/flags/tr.svg",
		en: "/flags/en.svg",
		es: "/flags/mx.svg",
		it: "/flags/it.svg",
		pt: "/flags/pt.svg",
		br: "/flags/br.svg",
		th: "/flags/th.svg",
		ru: "/flags/ru.svg",
		fa: "/flags/fa.svg",
	};
	const renderLanguageOption = (langCode) => {
		if (!isLanguageSupported(langCode)) return null;

		return (
			<img
				src={flags[langCode]}
				className={`${currentLanguage === langCode ? "active" : ""}`}
				onClick={changeLang.bind(this, langCode)}
			/>
		);
	};

	const languageNames = {
		"tr": "TÜRKÇE",
		"es": "ESPAÑOL",
		"pt": "PORTUGUÊS",
		"it": "ITALIANO",
		"en": "ENGLISH",
	};

	// const handleLanguage = () => {
	// 	const tenant = window.TENANT;
	// 	const tenantCode = tenant.split("-").pop();

	// 	const hasTenant = LANGUAGES.find((lang) => lang.code === tenantCode);

	// 	if (hasTenant) {
	// 		return [tenantCode, "en"];
	// 	} else {
	// 		return ["en"];
	// 	}
	// };

	return (
		<Translate>
			{({ translate }) => (
				<ChangeLanguageWrapper>
					<div className="change-lang-header">{translate("Change Language")}</div>
					{window.HAS_ONLY_CURRENT_LANGUAGE && window.LANGUAGE_HAS_FLAG ? (
						<LanguageWrapper>
							{LANGUAGES.map((lang) => {
								// const lang = LANGUAGES.find((lang) => lang.code === code);
								return (
									<img
										key={`lang-${lang.code}`}
										src={flags[lang.code]}
										className={`${
											currentLanguage === lang.code ? "active" : ""
										}`}
										onClick={() => changeLang(lang.code)}
									/>
								);
							})}
						</LanguageWrapper>
					) : (
						<LanguageWrapper className="language-wrapper">
							{renderLanguageOption("en")}
							{renderLanguageOption("tr")}
							{renderLanguageOption("es")}
							{renderLanguageOption("pt")}
							{renderLanguageOption("it")}
						</LanguageWrapper>
					)}
					<ActiveLanguage>{languageNames[currentLanguage]}</ActiveLanguage>
				</ChangeLanguageWrapper>
			)}
		</Translate>
	);
};

const mapStateToProps = (state) => ({
	banners: state.cms.containerData,
	translate: getTranslate(state.localize),
	loading: state.cms.loading,
	user: state.auth.user,
	currentLanguage: getActiveLanguage(state.localize).code,
	supportedLanguages: getLanguages(state.localize),
});

const mapDispatchToProps = {
	setActiveLanguage,
	setLanguage,
};
export default connect(mapStateToProps, mapDispatchToProps)(ChangeLanguage);
